import { PropsWithChildren } from 'react';
import { Box } from '@mui/material';

export const FloatingBannerContainer = ({ children }: PropsWithChildren) => (
  <Box sx={{ width: '100vw', position: 'fixed', zIndex: 1000 }}>{children}</Box>
);
